export default "__VITE_ASSET__5WiTLaD4__"